import React, { useState, useContext } from 'react'
import {
  Icon,
  Breadcrumb,
  Popover,
  Divider,
  Menu,
  Dropdown,
  Radio,
  message
} from 'antd'
import FileModal from './FileModal'
//import { StringResources } from '../../share/StringResources'
import CreateFolderModal from '../file/CreateFolderModal'
import { createFolder } from '../../lib/pouchDb'
import AuthContext from '../../contexts/AuthContext'
import VaultContext from '../../contexts/VaultContext'
import { useSelector, useDispatch } from 'react-redux'
import Button from '../override/Button'
import { onError } from '../../lib/sentry'
import ResponsiveBreadCrumb from './ResponsiveBreadCrumb'
import { useTranslation } from 'react-i18next'
import { checkPermission, removeHtmlTags } from './../../share/helpers'
import { ACCESS_LEVEL } from './../../share/Constants'
import { fetchOtherPendingDocuments } from '../../features/documents/otherDocumentsSlice'
import { fetchOtherContacts } from './../../features/contacts/otherContactsSlice'
import { useMutation } from 'react-apollo-hooks'
import { createS3Change } from '../../graphql/mutations'
import { useMediaQuery } from '@material-ui/core'
import { ThemeContext } from 'styled-components'

export default function FileNav(props) {
  const [createFolderVisible, setCreateFolderVisible] = useState(false)
  const [fileUploadVisible, setFileUploadVisible] = useState(false)
  const [isSaving, setIsSaving] = useState(false)
  const {
    breadcrumb,
    setBreadcrumb,
    searchPopover,
    searchResults,
    isSearchMode,
    isReadonly,
    filesCount,
    foldersCount,
    viewMode,
    setViewMode,
    contactDataSource,
    showStarredDocsOnly,
    setShowStarredDocsOnly,
    isStarred,
    setEnableCreateFile,
    exportMenu,
    selectedFolder,
    setIsShowSider,
    isShowSider
  } = props

  const { isProfessionalDeputy, isDelegateByPD, user } = useContext(AuthContext)
  const { masterKey, userId, permissions } = useContext(VaultContext)
  // const userId = user.username
  const { activeFolders, pendingFolders } = useSelector(state =>
    isReadonly ? state.otherDocuments : state.documents
  )
  const { activeLocations } = useSelector(state => state.locations)
  const { accessLevel } = useSelector(state => state.settings)
  const theme = useContext(ThemeContext)
  const isHdUp = useMediaQuery(theme.breakpoints.up('hd'))
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const isPendingFolder =
    !isProfessionalDeputy &&
    (!isDelegateByPD || !isReadonly) &&
    pendingFolders.some(f => f.path === breadcrumb)

  let createForm
  const createFormRef = fr => {
    createForm = fr
  }

  const [addS3Change] = useMutation(createS3Change)

  const navigateTo = (link, e) => {
    e?.preventDefault && e.preventDefault()

    const end = link ? breadcrumb.indexOf(link) + link.length + 1 : 0
    const newBreadcrumb = breadcrumb.substring(0, end)
    setBreadcrumb(newBreadcrumb)
  }

  const handleCreateFolder = callback => {
    const { form } = createForm.props
    form.validateFields(async (err, values) => {
      if (err) {
        return
      }

      removeHtmlTags(values)
      setIsSaving(true)
      try {
        const isPending =
          (isProfessionalDeputy || (isDelegateByPD && isReadonly)) &&
          accessLevel === ACCESS_LEVEL.NEED_APPROVAL
        
        await createFolder(
          user,
          userId,
          breadcrumb,
          masterKey,
          values.folderIcon,
          values.folderType,
          values.location,
          values.folderName,
          activeFolders,
          isPending
        )
        if (isPending) {
          dispatch(fetchOtherPendingDocuments(userId, masterKey))
        } else {
          dispatch(fetchOtherContacts(userId, masterKey))
        }

        message.success(t('SUCCESSFULLY_CREATED_FOLDER'))
        form.resetFields()
        localStorage.setItem('NotReload', true)
        addS3Change({
          variables: {
            message: 'documents, pendingDocuments, locations',
            userId: userId
          }
        })
        setCreateFolderVisible(false)
      } catch (err) {
        message.error(t('FAILED_TO_CREATE_FOLDER'))
        onError(err)
      } finally {
        setIsSaving(false)
        callback()
      }
    })
  }

  const handleCancel = () => {
    setCreateFolderVisible(false)
    createForm.props.form.resetFields()
  }

  const menu = (
    <Menu>
      <Menu.Item key="1" onClick={() => setCreateFolderVisible(true)}>
        <Icon type="folder" />
        {t('FOLDER')}
      </Menu.Item>
      <Menu.Item key="2" onClick={() => setEnableCreateFile(true)}>
        <Icon type="file-text" />
        {t('TEXT_FILE')}
      </Menu.Item>
    </Menu>
  )

  const handleModeChange = e => {
    setViewMode(e.target.value)
  }

  return (
    <div
      className="file-nav-hd"
      style={{
        padding: '20px 0',
        margin: '0 20px',
        border: 'solid #efefef',
        borderWidth: '1px 0',
        gap: !isHdUp && isShowSider ? '30px' : 0
      }}
    >
      <div>
        <ResponsiveBreadCrumb
          path={breadcrumb}
          separator=">"
          navigateTo={navigateTo}
          homeLink={
            isStarred ? (
              <Breadcrumb.Item
                href=""
                onClick={e => {
                  setShowStarredDocsOnly(true)
                  navigateTo('', e)
                }}
              >
                <Icon
                  type="star"
                  style={{ fontSize: 16, color: '#FFC54E' }}
                  theme={'filled'}
                />
                <span>{t('FAVOURITES')}</span>
              </Breadcrumb.Item>
            ) : (
              <Breadcrumb.Item href="" onClick={e => navigateTo('', e)}>
                <Icon type="home" />
                <span>{t('HOME')}</span>
              </Breadcrumb.Item>
            )
          }
        />

        <div className="sub-title" style={{ marginLeft: 18 }}>
          <div>
            {foldersCount} {t('FOLDERS').toLowerCase()} & {filesCount}{' '}
            {t('FILES').toLowerCase()}
          </div>
          {/* <div>
            {pendingFoldersCount} {t('PENDING_FOLDES').toLowerCase()} &{' '}
            {pendingFilesCount} {t('PENDING_FILES').toLowerCase()}
          </div> */}
        </div>
      </div>

      <div
        className={!isHdUp && isShowSider ? 'file-actions-hd' : 'file-actions'}
      >
        {isSearchMode && (
          <>
            {t('SEARCH_RESULTS')}:{' '}
            <span style={{ marginLeft: 5 }}>
              <strong>{searchResults.length} </strong>
              {t('FILES').toLowerCase()}
            </span>
            <Divider type="vertical" />
          </>
        )}

        <Dropdown overlay={exportMenu} trigger={['click', 'hover']}>
          <Button>
            {t('EXPORT')} <Icon type="down" />
          </Button>
        </Dropdown>
        <Divider type="vertical" />

        <Popover
          placement="bottomRight"
          title={t('SEARCH')}
          content={searchPopover}
          trigger="click"
        >
          <Button type="default">{t('SEARCH')}</Button>
        </Popover>

        {((!isReadonly && !showStarredDocsOnly && !isProfessionalDeputy) ||
          ((isProfessionalDeputy || (isDelegateByPD && isReadonly)) &&
            accessLevel &&
            accessLevel !== ACCESS_LEVEL.DENY) ||
          checkPermission(permissions, selectedFolder?._id)) && (
          <>
            <Divider type="vertical" />
            <Button
              disabled={isPendingFolder}
              onClick={() => {
                setFileUploadVisible(true)
              }}
              type="primary"
              icon="cloud-upload"
              className="tour-create-file-button"
            >
              {t('UPLOAD')}
            </Button>
            <Divider type="vertical" />
            <Dropdown
              disabled={isPendingFolder}
              overlay={menu}
              trigger={['click', 'hover']}
            >
              <Button type="primary">
                {t('CREATE_NEW')} <Icon type="down" />
              </Button>
            </Dropdown>
          </>
        )}
        <Divider type="vertical" />
        <Radio.Group defaultValue={viewMode} onChange={handleModeChange}>
          <Radio.Button value="list">
            <Icon type="bars" style={{ fontSize: 16 }} />
          </Radio.Button>
          <Radio.Button value="grid">
            <Icon type="appstore" style={{ fontSize: 16 }} />
          </Radio.Button>
        </Radio.Group>
        {!isReadonly && (
          <>
            <Divider type="vertical" />

            <Button
              style={{ height: 32 }}
              onClick={() => setIsShowSider(!isShowSider)}
            >
              <Icon
                style={{ fontSize: 16, borderRadius: 5 }}
                className="trigger"
                type={isShowSider ? 'menu-unfold' : 'menu-fold'}
              />
            </Button>
          </>
        )}
      </div>
      <CreateFolderModal
        wrappedComponentRef={createFormRef}
        visible={createFolderVisible}
        handleSaveFolder={handleCreateFolder}
        handleCancel={handleCancel}
        folders={activeFolders}
        breadcrumb={breadcrumb}
        isSaving={isSaving}
        isReadonly={isReadonly}
        activeLocations={activeLocations}
      />
      <FileModal
        visible={fileUploadVisible}
        setVisible={setFileUploadVisible}
        folderKey={breadcrumb}
        contactDataSource={contactDataSource}
      />
    </div>
  )
}
